import { render, staticRenderFns } from "./proxyPosMemberList.vue?vue&type=template&id=071e974a"
import script from "./proxyPosMemberList.vue?vue&type=script&lang=js"
export * from "./proxyPosMemberList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports